export default {
  setAccessToken(state, payload) {
    state.accessToken = payload.token;
  },
  setUser(state, payload) {
    state.account = payload.account;
  },
}